/* eslint-disable no-console */
import { isHidden } from '../utils/html-utils';

import Breakpoint from './breakpoint';

const addListeners = (options) => {
  const {
    container,
    footer,
    header,
    sidebar,
    sidebarTopMargin,
    stickyToggle,
  } = options;
  const parent = sidebar.parentNode;

  const updateSidebarDims = () => {
    sidebar.style.maxHeight = `${window.innerHeight - (header.clientHeight + sidebarTopMargin)}px`;
    if (parent.clientWidth !== 0) {
      sidebar.style.width = `${parent.clientWidth}px`;
    }
  };

  const updateSidebarPosition = () => {
    if (window.innerWidth < Breakpoint.MD.minWidth) {
      sidebar.removeAttribute('style');
      sidebar.classList.remove(stickyToggle);
      return;
    }
    if (!isHidden(sidebar) && container.clientHeight === sidebar.clientHeight) {
      sidebar.removeAttribute('style');
      return;
    }
    if (isHidden(sidebar) && !sidebar.classList.contains(stickyToggle)) {
      sidebar.removeAttribute('style');
      return;
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const sidebarTop = sidebar.parentNode.getBoundingClientRect().top + scrollTop;
    // console.log(`(${sidebarTop}/${window.pageYOffset + header.clientHeight}), stickyToggle: ${sidebar.classList.contains(stickyToggle)}`);
    const footerTop = footer.getBoundingClientRect().top + scrollTop;
    // console.log(`(${footerTop - window.innerHeight}/${window.pageYOffset})`);
    if (footerTop - window.innerHeight <= window.pageYOffset) {
      if (sidebar.classList.contains(stickyToggle)) {
        sidebar.classList.remove(stickyToggle);
        sidebar.removeAttribute('style');
        sidebar.style.position = 'absolute';
        sidebar.style.top = `${Math.max(0, window.pageYOffset - sidebarTop)}px`;
        sidebar.style.width = '100%';
      }
      return;
    }
    if (sidebarTop <= window.pageYOffset + header.clientHeight + sidebarTopMargin && sidebar.classList.contains(stickyToggle)) {
      return;
    }
    if (sidebarTop > window.pageYOffset + header.clientHeight + sidebarTopMargin && !sidebar.classList.contains(stickyToggle)) {
      return;
    }
    if (sidebarTop <= window.pageYOffset + header.clientHeight + sidebarTopMargin) {
      sidebar.classList.add(stickyToggle);
      sidebar.style.top = `${header.clientHeight + sidebarTopMargin}px`;
      sidebar.style.position = 'fixed';
      updateSidebarDims();
    } else {
      sidebar.classList.remove(stickyToggle);
      sidebar.removeAttribute('style');
    }
  };

  window.addEventListener('scroll', () => {
    updateSidebarPosition();
  });

  window.addEventListener('resize', () => {
    if (!isHidden(sidebar) && container.clientHeight === sidebar.clientHeight) {
      return;
    }
    updateSidebarPosition();
    updateSidebarDims();
  });

  updateSidebarPosition();
};

const stickySidebar = (options) => {
  addListeners(options);
};

export default stickySidebar;
/* eslint-enable no-console */
